import script from "./FinanceIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceIndex.vue?vue&type=script&setup=true&lang=js"

import "./FinanceIndex.vue?vue&type=style&index=0&id=1b08c1fd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b08c1fd"]])

export default __exports__